import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import { useAuth } from "../../contexts/AuthContext";
import { removeFromCart } from "./removeFromCart";
import { Link } from "react-router-dom";
import PayPalPayment from "../payment/PayPalPayment";

interface Product {
  id: string;
  name: string;
  description: string;
  price: string;
  image: string;
}

const CartPage = () => {
  const [cartItems, setCartItems] = useState<Product[]>([]);
  const { user } = useAuth();

  const calculateTotal = (cartItems: Product[]) => {
    return cartItems.reduce(
      (total, product) => total + parseFloat(product.price),
      0
    );
  };

  const fetchCartItems = async () => {
    const cartDocRef = doc(db, "cart", user.uid);
    try {
      const cartSnap = await getDoc(cartDocRef);
      if (cartSnap.exists()) {
        const cartData = cartSnap.data();
        const productIds = Object.keys(cartData).filter((key) => cartData[key]);

        const products = await Promise.all(
          productIds.map(async (productId) => {
            const productDocRef = doc(db, "proudcts", productId);
            const productSnap = await getDoc(productDocRef);
            const productData = productSnap.data() as Product;

            return { ...productData, id: productId }; // Только добавляем id, если его нет
          })
        );

        console.log("Products:", products); // Логируем все товары перед установкой в состояние
        setCartItems(products);
      }
    } catch (error) {
      console.error("Error fetching cart items:", error);
    }
  };

  const handleRemove = async (productId: string) => {
    try {
      await removeFromCart(user.uid, productId);
      setCartItems((prev) =>
        prev.filter((product) => product.id !== productId)
      );
    } catch (error) {
      console.error("Error removing from cart:", error);
    }
  };

  useEffect(() => {
    fetchCartItems();
  }, [user]);

  const total = calculateTotal(cartItems);

  return (
    <div className=" px-5 lg:px-36 py-6 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-6 text-center">Your Cart</h1>
      {cartItems.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cartItems.map((product) => (
            <div
              key={product.id}
              className="bg-white shadow-lg rounded-lg p-4 border border-gray-200"
            >
              <Link to={`/products/${product.id}`}>
                <div className="flex justify-center items-center">
                  <img
                    className="h-64"
                    src={product.image}
                    alt={product.name}
                  />
                </div>
              </Link>
              <Link
                to={`/products/${product.id}`}
                className="text-xl font-semibold mb-2 truncate"
              >
                {product.name}
              </Link>
              <p className="text-gray-700 mb-4 line-clamp-2">
                {product.description}
              </p>
              <p className="text-lg font-bold mb-4">${product.price}</p>
              <button
                onClick={() => {
                  console.log("Product ID to remove:", product.id); // Логируем перед удалением
                  handleRemove(product.id);
                }}
                className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
              >
                Remove
              </button>
            </div>
          ))}
          <div className="mt-6 text-center">
            <h3 className="text-xl font-semibold">
              Total: ${total.toFixed(2)}
            </h3>
            <PayPalPayment totalAmount={total} />{" "}
          </div>
        </div>
      ) : (
        <p className="text-center text-gray-600">Your cart is empty.</p>
      )}
    </div>
  );
};

export default CartPage;
